import React from 'react';
import { Box, Link } from '@mui/material';
import { VoyageModel } from 'models/VoyageModel';


type VoyageLinkProps = {
    voyage: VoyageModel,
}

const VoyageLink = ({voyage}: VoyageLinkProps) => {
    return (
        <Box>
            <Link
                href={`/voyage/${voyage.id}`}
            >
                {voyage.number}
            </Link>
            <br/>
            {voyage.pod.code}
        </Box>
    );
};

export default VoyageLink;
